window.addEventListener('load', function (event) {
  const variantsSelect = document.querySelector('select[data-variants]');
  if (variantsSelect) initVariantSelector(variantsSelect);
  variantsSelect.parentElement.removeChild(variantsSelect);
});

function initVariantSelector(selector) {
  const productVariants = [];
  for (const option of selector.options) {
    const variantInfo = {
      id: option.value,
      price: option.dataset.price,
      values: option.dataset.values,
      rawPrice: option.dataset.raw_price,
      price_per_servings: option.dataset.price_per_servings,
      options: option.dataset.values.split('|'),
      available: option.dataset.hasOwnProperty('available'),
    };
    productVariants.push(variantInfo);
  }

  const productId = selector.dataset.variants;
  if (!productId) return;
  const productForm = document.querySelector(`form[data-product_form='${productId}']`);
  const productOptions = document.querySelectorAll(`[data-variant_options='${productId}']`);
  const productPrice = document.querySelector("[data-output='price']");
  const sellingPlanInput = productForm.querySelector("input[name='selling_plan']");
  if (productOptions.length) {
    // const convertCurrencyEvent = new CustomEvent('CurrencyConverterUpdate', { detail: { outputs: [productPrice] } });
    const variantUpdateEvent = new CustomEvent('ProductVariantUpdate', { detail: { variant: 'test' } });
    productOptions.forEach((option) => {
      const isImagesTrigger = option.dataset.hasOwnProperty('variantImagesTrigger');
      const isFamilyTrigger = option.dataset.hasOwnProperty('variantFamilyTrigger');
      const values = option.querySelectorAll('[data-value]');
      values.forEach((value) => {
        value.addEventListener('click', function () {
          if (value.dataset.hasOwnProperty('selected')) return;
          if (isFamilyTrigger) return;
          const current = option.querySelector('[data-selected]');
          current.removeAttribute('data-selected');
          value.dataset.selected = true;
          option.dataset.option_value = value.dataset.value;
          const selected = updateVariant(productOptions, productVariants, productForm);
          toggleForm(productForm, selected ? selected.available : false);
          if (isImagesTrigger)
            filterVariantImages(
              option.dataset.variant_options.toLowerCase(),
              option.dataset.option_value.toLowerCase()
            );
          if (selected) {
            productPrice.dataset.money = selected.rawPrice;
            //document.body.dispatchEvent(convertCurrencyEvent);
            document.body.dispatchEvent(variantUpdateEvent);
          }
        });
      });
      if (isImagesTrigger) {
        window.addEventListener('load', function () {
          filterVariantImages(option.dataset.variant_options.toLowerCase(), option.dataset.option_value.toLowerCase());
        });
      }
    });
  }
}

function updateVariant(options, variants, form) {
  const selectedOptions = [];
  options.forEach((option) => {
    selectedOptions.push(option.dataset.option_value);
  });
  const selectedVariant = variants.find((variant) => variant.values === selectedOptions.join('|'));

  if (!selectedVariant) return false;

  // var event = new CustomEvent('OrdersifyFormChange', { detail: { variantID: selectedVariant.id } });
  // document.body.dispatchEvent(event);
  const variantInput = form.querySelector("input[name='id']");
  if (variantInput) variantInput.value = selectedVariant.id;
  const sellingPlanInput = form.querySelector("input[name='selling_plan']");
  updateProductUrl(variantInput.value, sellingPlanInput ? sellingPlanInput.value : null);

  const variantOutput = document.querySelectorAll('[data-output]');
  variantOutput.forEach((output) => {
    if (output.dataset.output === 'images') {
      const current = output.querySelector('[data-active]');
      if (current) {
        current.classList.replace('db', 'dn');
        current.removeAttribute('data-active');
      }
      const updated = output.querySelector("[data-variant='" + selectedVariant.id + "']");
      if (updated) {
        updated.classList.replace('dn', 'db');
        updated.dataset.active = true;
      }
    } else {
      output.textContent = selectedVariant[output.dataset.output];
    }
  });

  if(BOLD && BOLD.BsubWidget._renderPrices){
     BOLD.BsubWidget._renderPrices()
  }

  return selectedVariant;
}

function toggleForm(form, isAvailable) {
  const submit = form.querySelector("input[type='submit']");

  if (isAvailable) {
    if (submit.disabled) submit.disabled = false;
  } else {
    if (!submit.disabled) submit.disabled = true;
  }
}

function formatSelectOptionsText(options, current, prepend, append) {
  for (const option of options) {
    if (option.index === current) {
      if (prepend) option.text = prepend + option.text;
      if (append) option.text = option.text + append;
    } else {
      if (prepend) option.text = option.text.replace(prepend, '');
      if (append) option.text = option.text.replace(append, '');
    }
  }
}

function filterVariantImages(option, value) {
  $('[data-variant-images]').slick('slickUnfilter');
  $('[data-variant-images]').slick('slickFilter', `.${option}-${value}, .options-all`);
}

/* const quantityInput = document.querySelector("div[data-input='quantity']");
if (quantityInput) {
  const productQuantity = document.querySelector("input[name='quantity']");
  initQuantityInput(quantityInput, function (input, value) {
    productQuantity.value = value;
  });
} */
